import { render, staticRenderFns } from "./PgaOrderRequirementsReviewDetails.vue?vue&type=template&id=916d2fa0&"
import script from "./PgaOrderRequirementsReviewDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOrderRequirementsReviewDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VLayout,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('916d2fa0')) {
      api.createRecord('916d2fa0', component.options)
    } else {
      api.reload('916d2fa0', component.options)
    }
    module.hot.accept("./PgaOrderRequirementsReviewDetails.vue?vue&type=template&id=916d2fa0&", function () {
      api.rerender('916d2fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/components/details/sections/PgaOrderRequirementsReviewDetails.vue"
export default component.exports